export default __webpack_public_path__ + "static/media/SAKS.ca57d437.svg";